// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Hooks = require("../../../utils/Hooks.bs.js");
let React = require("react");
let FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
let TipBoxes = require("../../../reason/clients/components/TipBoxes.bs.js");
let DateFnsTz = require("../../../reason/common/DateFns/DateFnsTz.bs.js");
let View__Jsx3 = require("../../../uikit/reason/helpers/View__Jsx3.bs.js");
let Form__Label = require("../../../uikit/reason/atoms/Form/Form__Label.bs.js");
let CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
let TogglesGroup = require("../../../uikit/reason/molecules/TogglesGroup/TogglesGroup.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let AutocompleteV5 = require("../../autocomplete/AutocompleteV5.bs.js");
let Form__Checkbox = require("../../../uikit/reason/atoms/Form/Form__Checkbox.bs.js");
let ReactDatepicker = require("../../../uikit/atoms/Datepicker/ReactDatepicker.bs.js");
let Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");
let PropertyWizardRelayMLSTiming_draft_graphql = require("../../../__generated__/PropertyWizardRelayMLSTiming_draft_graphql.bs.js");
let PropertyWizardFormRelay__Validators__MLSTiming = require("./PropertyWizardFormRelay__Validators__MLSTiming.bs.js");
let PropertyWizardRelayMLSTiming_formState_graphql = require("../../../__generated__/PropertyWizardRelayMLSTiming_formState_graphql.bs.js");

let convertFragment = PropertyWizardRelayMLSTiming_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayMLSTiming_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayMLSTiming_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayMLSTiming_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayMLSTiming_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayMLSTiming_draft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayMLSTiming_draft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment_mlsListingTypeV5_decode = PropertyWizardRelayMLSTiming_draft_graphql.Utils.mlsListingTypeV5_decode;

let DraftFragment_mlsListingTypeV5_fromString = PropertyWizardRelayMLSTiming_draft_graphql.Utils.mlsListingTypeV5_fromString;

let DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  mlsListingTypeV5_decode: DraftFragment_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: DraftFragment_mlsListingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardRelayMLSTiming_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayMLSTiming_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayMLSTiming_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayMLSTiming_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayMLSTiming_formState_graphql.node, convertFragment$1, fRef);
}

let FormStateFragment_localDraftMlsStatus_decode = PropertyWizardRelayMLSTiming_formState_graphql.Utils.localDraftMlsStatus_decode;

let FormStateFragment_localDraftMlsStatus_fromString = PropertyWizardRelayMLSTiming_formState_graphql.Utils.localDraftMlsStatus_fromString;

let FormStateFragment = {
  localDraftMlsStatus_decode: FormStateFragment_localDraftMlsStatus_decode,
  localDraftMlsStatus_fromString: FormStateFragment_localDraftMlsStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function getOptionLabel(x) {
  switch (x) {
    case "ACTIVE" :
      return "Yes, I'm adding to the MLS as Active (won't be added to MLS as Coming Soon)";
    case "COMING_SOON" :
      return "Yes, I'm adding to the MLS as a Coming Soon";
    case "OFF_MLS" :
      return "No, I have no MLS plans in the next month";
  }
}

let Option = {
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionLabel
};

let options = [
  "ACTIVE",
  "COMING_SOON",
  "OFF_MLS"
];

let SelectWithComingSoon = {
  Option: Option,
  options: options
};

function getOptionLabel$1(x) {
  if (x === "yes") {
    return "Yes";
  } else {
    return "No";
  }
}

let Option$1 = {
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionLabel$1
};

let options$1 = [
  "yes",
  "no"
];

let SelectYesOrNo = {
  Option: Option$1,
  options: options$1
};

function PropertyWizardRelay__MLSTiming(props) {
  let match = PropertyWizardFormRelay.Context.use();
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayMLSTiming_draft_graphql.node, convertFragment, props.draft);
  let draftProperty = draft.draftProperty;
  let formState = RescriptRelay_Fragment.useFragment(PropertyWizardRelayMLSTiming_formState_graphql.node, convertFragment$1, props.formState);
  let stepHasBeenTouched = formState.stepMlsTimingTouched;
  let comingSoonEnabled = draft.chapterPreferenceMlsComingSoonActivated;
  let willShow = PropertyWizardRelayUtils.FormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (dp, value) => {
      let newrecord = {...dp};
      newrecord.willShow = value;
      return newrecord;
    }
  }, stepHasBeenTouched, draftProperty.willShow, PropertyWizardFormRelay__Validators__MLSTiming.WillShow.useIsValid());
  let willAcceptOffers = PropertyWizardRelayUtils.FormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (dp, value) => {
      let newrecord = {...dp};
      newrecord.willAcceptOffers = value;
      return newrecord;
    }
  }, stepHasBeenTouched, draftProperty.willAcceptOffers, PropertyWizardFormRelay__Validators__MLSTiming.WillAcceptOffers.useIsValid());
  let onMlsAtValid = PropertyWizardFormRelay__Validators__MLSTiming.OnMLSAt.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  let tmp;
  if (onMlsAtValid !== undefined) {
    if (typeof onMlsAtValid === "object") {
      let e = onMlsAtValid.VAL;
      tmp = {
        NAME: "Error",
        VAL: e === "required" ? "is required" : (
            e === "alreadyOnMlsAndAfterToday" ? "must be before today when the property is already on MLS" : "must be after today"
          )
      };
    } else {
      tmp = "Valid";
    }
  } else {
    tmp = undefined;
  }
  let onMlsAt = PropertyWizardRelayUtils.FormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (dp, value) => {
      let newrecord = {...dp};
      newrecord.onMlsAt = value;
      return newrecord;
    }
  }, stepHasBeenTouched, draftProperty.onMlsAt, tmp);
  let mlsListingTypeValid = PropertyWizardFormRelay__Validators__MLSTiming.MLSListingType.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  let tmp$1;
  if (mlsListingTypeValid !== undefined) {
    if (typeof mlsListingTypeValid === "object") {
      let e$1 = mlsListingTypeValid.VAL;
      tmp$1 = {
        NAME: "Error",
        VAL: e$1 === "alreadyOnMlsAndNotActive" ? "property is already on the MLS and therefore must be set as Active on MLS" : (
            e$1 === "required" ? "is required" : "property is already on the MLS. You must either not change this, or set it to Active on MLS"
          )
      };
    } else {
      tmp$1 = "Valid";
    }
  } else {
    tmp$1 = undefined;
  }
  let mlsListingType = PropertyWizardRelayUtils.FormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (dp, value) => {
      let newrecord = {...dp};
      newrecord.mlsListingType = value;
      return newrecord;
    }
  }, stepHasBeenTouched, draftProperty.mlsListingType, tmp$1);
  let previousMlsListingType = Hooks.usePrevious(mlsListingType.value);
  React.useEffect(() => {
    if (previousMlsListingType !== mlsListingType.value) {
      let match = mlsListingType.value;
      if (match !== undefined) {
        switch (match) {
          case "COMING_SOON" :
            willShow.onChange(false);
            willAcceptOffers.onChange(false);
            break;
          case "ACTIVE" :
          case "OFF_MLS" :
            willShow.onChange(true);
            willAcceptOffers.onChange(true);
            break;
        }
      }
    }
  }, [
    mlsListingType.value,
    previousMlsListingType
  ]);
  let tmp$2;
  if (comingSoonEnabled) {
    let match$1 = mlsListingType.status;
    tmp$2 = JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
      getOptionLabel: getOptionLabel,
      getOptionValue: getOptionLabel,
      onBlur: param => mlsListingType.onBlur(),
      onChange: mlsListingType.onChange,
      options: options,
      value: mlsListingType.value,
      status: match$1 !== undefined ? (
          match$1 === "ok" ? "Success" : "Failure"
        ) : "Neutral"
    });
  } else {
    let match$2 = mlsListingType.value;
    let tmp$3;
    if (match$2 !== undefined) {
      switch (match$2) {
        case "ACTIVE" :
          tmp$3 = "yes";
          break;
        case "COMING_SOON" :
          tmp$3 = undefined;
          break;
        case "OFF_MLS" :
          tmp$3 = "no";
          break;
      }
    } else {
      tmp$3 = undefined;
    }
    let match$3 = mlsListingType.status;
    tmp$2 = JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
      getOptionLabel: getOptionLabel$1,
      getOptionValue: getOptionLabel$1,
      onBlur: param => mlsListingType.onBlur(),
      onChange: value => mlsListingType.onChange(value !== undefined ? (
          value === "yes" ? "ACTIVE" : "OFF_MLS"
        ) : undefined),
      options: options$1,
      value: tmp$3,
      status: match$3 !== undefined ? (
          match$3 === "ok" ? "Success" : "Failure"
        ) : "Neutral"
    });
  }
  let match$4 = draftProperty.mlsListingType;
  let tmp$4;
  let exit = 0;
  if (match$4 !== undefined) {
    switch (match$4) {
      case "ACTIVE" :
      case "COMING_SOON" :
        exit = 1;
        break;
      case "OFF_MLS" :
        tmp$4 = null;
        break;
    }
  } else {
    tmp$4 = null;
  }
  if (exit === 1) {
    let match$5 = draftProperty.mlsListingType;
    let tmp$5;
    if (match$5 !== undefined) {
      switch (match$5) {
        case "COMING_SOON" :
          tmp$5 = "Date planned to go Active on MLS";
          break;
        case "ACTIVE" :
        case "OFF_MLS" :
          tmp$5 = "Approximate MLS date";
          break;
      }
    } else {
      tmp$5 = "Approximate MLS date";
    }
    let match$6 = formState.mlsStatus;
    let tmp$6;
    switch (match$6) {
      case "OnMls" :
      case "OnMlsButAllowed" :
        tmp$6 = undefined;
        break;
      default:
        let tmp$7 = match.mode;
        if (typeof tmp$7 !== "object") {
          tmp$6 = Primitive_option.some(CalendarDate.today(DateFnsTz.Timezone.make(draft.timeZone)));
        } else {
          switch (tmp$7.TAG) {
            case "Edit" :
            case "Rebroadcast" :
              tmp$6 = undefined;
              break;
            case "BroadcastQuietSeller" :
              tmp$6 = Primitive_option.some(CalendarDate.today(DateFnsTz.Timezone.make(draft.timeZone)));
              break;
          }
        }
    }
    let match$7 = formState.mlsStatus;
    let tmp$8;
    switch (match$7) {
      case "OnMls" :
      case "OnMlsButAllowed" :
        tmp$8 = Primitive_option.some(CalendarDate.today(DateFnsTz.Timezone.make(draft.timeZone)));
        break;
      default:
        tmp$8 = undefined;
    }
    tmp$4 = JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
      width: 12,
      widthMd: 3,
      children: [
        JsxRuntime.jsx(Form__Label.make, {
          labelText: tmp$5
        }),
        JsxRuntime.jsx(ReactDatepicker.make, {
          placeholderText: "Approximate date",
          onChange: v => onMlsAt.onChange(v),
          selected: draftProperty.onMlsAt,
          minDate: tmp$6,
          maxDate: tmp$8,
          status: onMlsAt.status
        }),
        JsxRuntime.jsx(Form__Components.FieldError.make, {
          valid: onMlsAt.valid
        })
      ]
    });
  }
  let match$8 = draftProperty.propertyType;
  let tmp$9;
  tmp$9 = match$8 === "FOR_SALE" ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(Form__Checkbox.make, {
          onChange: evt => willShow.onChange(evt.target.checked),
          checked: Stdlib_Option.getOr(willShow.value, false),
          disabled: false,
          label: "Will show prior to MLS",
          mobileStyles: true
        }),
        JsxRuntime.jsx(Form__Checkbox.make, {
          onChange: evt => willAcceptOffers.onChange(evt.target.checked),
          checked: Stdlib_Option.getOr(willAcceptOffers.value, false),
          disabled: false,
          label: "Will accept offers prior to MLS",
          mobileStyles: true
        })
      ]
    }) : null;
  return JsxRuntime.jsxs(FormV5.FormSection.make, {
    tipbox: JsxRuntime.jsx(TipBoxes.PropertyWizard.MlsTimingWithComingSoon.make, {
      offMlsConfigurable: true
    }),
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: "Are you putting the property on the MLS in the next month?"
      }),
      tmp$2,
      JsxRuntime.jsx(Form__Components.FieldError.make, {
        valid: mlsListingType.valid
      }),
      JsxRuntime.jsx(View__Jsx3.make, {
        mt: "md",
        children: tmp$4
      }),
      JsxRuntime.jsx(View__Jsx3.make, {
        mt: "md",
        children: JsxRuntime.jsx(TogglesGroup.make, {
          children: tmp$9
        })
      })
    ]
  });
}

let Components;

let FormSection;

let Validators;

let FormUtils;

let Cell;

let TipBoxes$1;

let make = PropertyWizardRelay__MLSTiming;

exports.Components = Components;
exports.FormSection = FormSection;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.Cell = Cell;
exports.TipBoxes = TipBoxes$1;
exports.DraftFragment = DraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.SelectWithComingSoon = SelectWithComingSoon;
exports.SelectYesOrNo = SelectYesOrNo;
exports.make = make;
/* Hooks Not a pure module */
